import getDictionaryReduxModule from '../../../utils/redux/getDictionaryReduxModule';
import Api from '../../../utils/resourcesApi';

const { constants, actions, reducer, sagas } = getDictionaryReduxModule('USERS', Api.users.index);

export { constants, actions, reducer, sagas };
export default { constants, actions, reducer, sagas };

